export const userTypeValues = {
  admin: 1,
  client: 0,
  client_adm: 2,
};

export interface IUserTypeOptions {
  label: string;
  value: number;
}

export const userTypeOptions: IUserTypeOptions[] = [
  { label: 'Daniel Law', value: 1 },
  { label: 'Cliente Administrador', value: 2 },
  { label: 'Cliente Daniel Law', value: 0 },
];

export const userTypeClient = [{ label: 'Cliente Daniel Law', value: 0 }];

export const userTypeOptionsForClientAdm = [
  { label: 'Cliente Daniel Law', value: 0 },
  { label: 'Cliente Administrador', value: 2 },
];

export const permissionTypeValues = {
  temporary: 'TEMPORARIA',
  permanent: 'PERMANENTE',
};

export const permissionTypeOptions = [
  { label: 'Permanente', value: permissionTypeValues.permanent },
  { label: 'Temporária', value: permissionTypeValues.temporary },
];
export const userStatusValues = {
  active: 'Ativo',
  inactive: 'Inativo',
};
export const userStatusLabels = {
  active: 'Ativo',
  inactive: 'Inativo',
};

export const userStatusClient = {
  active: 'Ativar',
  inactive: 'Desativar',
};
